import React from 'react';
import ProjectSubmissionModal from '@/components/module/projects/ProjectSubmissionModal';

/**
 * Submit PMO milestone batch to client (completion-request API). Editor has no separate Save — submit sends notes + attachments.
 */
export default function PmoSubmitToClientModal({
    open,
    onCancel,
    sidLabel = 'SID-1',
    presetHeading = 'Submission 1',
    descriptionHtml,
    onDescriptionChange,
    submissionDescriptionRaw,
    taskRows,
    onTaskRowClick,
    onSubmit,
    submitPending,
    submitDisabled,
    submitPermissionDenied,
    afterDescription,
    richTextEditorProps,
    mentionUsers,
    mentionMilestones,
    mentionSprints,
    modalSize,
    /** Read-only: submitted-to-client column — show API notes, links, tasks (no submit). */
    viewOnly = false,
    viewLinks,
    viewAttachments,
    viewClientAttachments,
    detailSections,
    descriptionSectionLabel,
    footerOverride,
}) {
    return (
        <ProjectSubmissionModal
            open={open}
            onCancel={onCancel}
            variant="submitToClient"
            sidLabel={sidLabel}
            submissionTitle={presetHeading}
            descriptionHtml={descriptionHtml}
            onDescriptionChange={viewOnly ? undefined : onDescriptionChange}
            submissionDescriptionRaw={submissionDescriptionRaw}
            afterDescription={afterDescription}
            richTextEditorProps={richTextEditorProps}
            mentionUsers={mentionUsers}
            mentionMilestones={mentionMilestones}
            mentionSprints={mentionSprints}
            modalSize={modalSize}
            taskRows={taskRows}
            onTaskRowClick={onTaskRowClick}
            onSubmit={onSubmit}
            submitPending={submitPending}
            submitDisabled={submitDisabled}
            submitPermissionDenied={submitPermissionDenied}
            emptyTasksMessage="No tasks on this submission yet."
            viewOnly={viewOnly}
            viewLinks={viewLinks}
            viewAttachments={viewAttachments}
            viewClientAttachments={viewClientAttachments}
            detailSections={detailSections}
            descriptionSectionLabel={descriptionSectionLabel ?? (viewOnly ? 'Submission notes' : 'Submission Description')}
            footerOverride={footerOverride}
        />
    );
}
